$(function(){
    // helper function to toggle a cinema show detail panel
    const toggleTrailer = function (placeholder, trailer) {
        const control = trailer.parentNode.querySelector('.c-cinema_show--trailer-control');
        const trailer_embed = trailer.querySelector('iframe');

        if (trailer.classList.contains('play')) {
            trailer.classList.remove('play');
            placeholder.classList.remove('play');
            control.classList.remove('play');
            trailer_embed.src = '';
            control.querySelector('span').innerHTML = 'Trailer einblenden';
        } else {
            trailer_embed.src = trailer_embed.dataset.src;
            trailer.classList.add('play');
            placeholder.classList.add('play');
            control.classList.add('play');
            control.querySelector('span').innerHTML = 'Trailer ausblenden';
        }
    };

    // cinema show toggles
    const cinema_toggles = document.querySelectorAll('.c-cinema_show--toggle');
    for (let i = 0; i < cinema_toggles.length; i++) {
        const toggle = cinema_toggles[i];
        toggle.onclick = (e) => {
            e.preventDefault();
            const film = toggle.parentNode;
            const detail = toggle.parentNode.querySelector('.c-cinema_show--detail');
            const trailer = toggle.parentNode.querySelector('.c-cinema_show--trailer');
            const placeholder = toggle.parentNode.querySelector('.c-cinema_show--trailer-placeholder');
            if (detail.classList.contains('open')) {
                detail.classList.remove('open');
                film.classList.remove('open');
                if (trailer.classList.contains('play')) {
                    toggleTrailer(placeholder, trailer);
                }
            } else {
                detail.classList.add('open');
                film.classList.add('open');
            }
        };
    }

    // cinema play trailer on image click
    const placeholder_controls = document.querySelectorAll('.c-cinema_show--trailer-placeholder');
    for (let j = 0; j < placeholder_controls.length; j++) {
        const placeholder = placeholder_controls[j];
        placeholder.onclick = (e) => {
            e.preventDefault();
            const trailer = placeholder.parentNode.querySelector('.c-cinema_show--trailer');
            toggleTrailer(placeholder, trailer);
        };
    }

    // cinema show trailer controls
    const trailer_controls = document.querySelectorAll('.c-cinema_show--trailer-control');
    for (let n = 0; n < trailer_controls.length; n++) {
        const trailer_control = trailer_controls[n];
        trailer_control.onclick = (e) => {
            e.preventDefault();
            const trailer = trailer_control.parentNode.parentNode.querySelector('.c-cinema_show--trailer');
            const placeholder = trailer_control.parentNode.parentNode.querySelector('.c-cinema_show--trailer-placeholder');
            toggleTrailer(placeholder, trailer);
        };
    }

    // helpers to deal with dates
    // const isToday = (date) => {
    //     const today = new Date();
    //     return date.getDate() === today.getDate() &&
    //         date.getMonth() === today.getMonth() &&
    //         date.getFullYear() === today.getFullYear();
    // };
    //
    // const isTomorrow = (date) => {
    //     const today = new Date();
    //     return (date.getDate() - 1) === today.getDate() &&
    //         date.getMonth() === today.getMonth() &&
    //         date.getFullYear() === today.getFullYear();
    // };
    //
    // const isAftertomorrow = (date) => {
    //     const today = new Date();
    //     return (date.getDate() - 2) === today.getDate() &&
    //         date.getMonth() === today.getMonth() &&
    //         date.getFullYear() === today.getFullYear();
    // };
    //
    // const isFriday = (date) => {
    //     // 5: Friday
    //     return date.getDay() === 5;
    // };
    //
    // const isWeekendDay = (date) => {
    //     // 6: Saturday, 0: Sunday
    //     return date.getDay() === 6 || date.getDay() === 0;
    // };
    //
    // // cinema ticket button logic depending on dates
    // const ticket_alert = document.querySelector('.c-cinema-alert');
    // const ticket_alert_bg = document.querySelector('.c-cinema-alert-bg');
    // const ticket_controls = document.querySelectorAll('.c-cinema_show--ticket a');
});

